/* Fuego & Fragancia — un solo formato de precio en toda la tienda.

   EL PROBLEMA QUE RESUELVE
   Varios guiones formateaban el precio con `Intl.NumberFormat` usando el idioma
   de la página. Eso parece lo correcto y no lo es: en inglés da "$31.31", pero
   en español el mismo importe sale "31,31 US$" — el símbolo detrás y el código
   del país delante de él. Así que el mismo producto mostraba un precio en un
   móvil en español y otro distinto en un escritorio en inglés, y ninguno de los
   dos coincidía con el que pinta Liquid en el servidor.

   Intl formatea según la CONVENCIÓN DEL IDIOMA. Una tienda tiene una sola
   convención, la suya, y la decide la persona dueña en los ajustes de Shopify
   (aquí: `${{amount}}`). Ese es el formato que usa el servidor en cada
   `{{ price | money }}`, y por tanto el único que puede usar el navegador si
   queremos que las dos mitades del sitio digan lo mismo.

   Este archivo implementa los comodines de Shopify sobre el formato real de la
   tienda, que llega desde Liquid en `window.ffMoneyFormat`.

   Uso:  window.ffMoney(3131)  ->  "$31.31"     (recibe CENTAVOS) */

(function () {
  var POR_DEFECTO = '${{amount}}';

  // Separa en miles y decimales al estilo pedido, sin depender del idioma
  // del navegador — que es justo la trampa de la que venimos.
  function partir(unidades, decimales, miles, coma) {
    var negativo = unidades < 0;
    var n = Math.abs(unidades);
    var fijo = decimales > 0 ? n.toFixed(decimales) : String(Math.round(n));
    var trozos = fijo.split('.');
    var entera = trozos[0];
    var resto = trozos[1] || '';

    entera = entera.replace(/\B(?=(\d{3})+(?!\d))/g, miles);

    var salida = entera;
    if (decimales > 0) salida += coma + resto;
    return (negativo ? '-' : '') + salida;
  }

  function formatear(centavos, formato) {
    var plantilla = formato || window.ffMoneyFormat || POR_DEFECTO;
    var unidades = (parseInt(centavos, 10) || 0) / 100;

    return plantilla.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, clave) {
      var sinDecimales = clave.indexOf('no_decimals') >= 0;
      var decimales = sinDecimales ? 0 : 2;

      // Los nombres son los de Shopify. El que no se reconoce cae en el
      // formato inglés, que es el de esta tienda.
      if (clave.indexOf('comma_separator') >= 0) return partir(unidades, decimales, '.', ',');
      if (clave.indexOf('apostrophe_separator') >= 0) return partir(unidades, decimales, "'", '.');
      if (clave.indexOf('space_separator') >= 0) return partir(unidades, decimales, ' ', ',');
      return partir(unidades, decimales, ',', '.');
    });
  }

  window.ffMoney = formatear;

  /* Para lo que llega de una API y puede venir de tres maneras distintas:
     en centavos ("3131"), en unidades ("31.31") o ya formateado ("$31.31").
     Se decide por lo que llega en vez de dar por hecho un formato. */
  window.ffMoneyLoose = function (valor) {
    if (valor === null || valor === undefined || valor === '') return '';
    var texto = String(valor);
    if (/[^\d.,\-]/.test(texto)) return texto; // ya trae símbolo: se respeta
    if (texto.indexOf('.') >= 0) return formatear(Math.round(parseFloat(texto) * 100));
    return formatear(parseInt(texto, 10));
  };
})();
